import React from "react";
import { motion } from "framer-motion";
import { Mail, MessageCircle, Clock, Send } from "lucide-react";

const EMAIL = "getcvaipro@gmail.com";

export const Contact = () => {
  return (
    <section
      id="contact"
      className="relative py-24 sm:py-32"
      data-testid="contact-section"
    >
      <div
        aria-hidden
        className="absolute left-1/2 -translate-x-1/2 top-1/3 h-[360px] w-[640px] rounded-full bg-blue-600/15 blur-[140px] pointer-events-none"
      />
      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">
            Contact
          </p>
          <h2
            className="mt-3 text-3xl md:text-4xl font-semibold tracking-tight text-white text-balance"
            data-testid="contact-headline"
          >
            Contact Us
          </h2>
          <p
            className="mt-4 text-zinc-400 text-balance"
            data-testid="contact-subheadline"
          >
            Need help or have questions? Contact us anytime.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative mx-auto mt-12 max-w-2xl"
          data-testid="contact-card"
        >
          <div
            aria-hidden
            className="absolute -inset-px rounded-3xl bg-gradient-to-r from-blue-500/40 via-indigo-500/30 to-purple-500/40 opacity-60"
          />
          <div className="relative rounded-3xl bg-gradient-to-b from-zinc-950 to-black border border-white/5 p-8 sm:p-10">
            <div className="flex flex-col items-center text-center">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-zinc-900 to-black">
                <Mail className="h-5 w-5 text-white" />
              </div>
              <p className="mt-5 text-sm text-zinc-400">Reach our team at</p>
              <a
                href={`mailto:${EMAIL}`}
                className="mt-2 text-xl sm:text-2xl font-medium tracking-tight text-white hover:text-zinc-300 transition-colors"
                data-testid="contact-email-link"
              >
                {EMAIL}
              </a>

              <a
                href={`mailto:${EMAIL}?subject=Question%20about%20CV%20AI%20PRO`}
                className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-zinc-200 transition-colors"
                data-testid="contact-cta-email"
              >
                <Send className="h-4 w-4" />
                Send us an email
              </a>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <a
                href={`mailto:${EMAIL}?subject=Question%20about%20CV%20AI%20PRO`}
                className="rounded-2xl border border-white/10 bg-zinc-950/60 p-5 text-left hover:border-white/20 hover:bg-zinc-950/80 transition-colors"
                data-testid="contact-tile-fast"
              >
                <Clock className="h-4 w-4 text-zinc-400" />
                <p className="mt-3 text-sm text-white">Fast response</p>
                <p className="mt-1 text-xs text-zinc-500">
                  Usually within a few hours
                </p>
              </a>
              <a
                href={`mailto:${EMAIL}?subject=Pre-sale%20question`}
                className="rounded-2xl border border-white/10 bg-zinc-950/60 p-5 text-left hover:border-white/20 hover:bg-zinc-950/80 transition-colors"
                data-testid="contact-tile-presale"
              >
                <MessageCircle className="h-4 w-4 text-zinc-400" />
                <p className="mt-3 text-sm text-white">Pre-sale questions</p>
                <p className="mt-1 text-xs text-zinc-500">
                  Pricing, format, industries
                </p>
              </a>
              <a
                href={`mailto:${EMAIL}?subject=Order%20Support`}
                className="rounded-2xl border border-white/10 bg-zinc-950/60 p-5 text-left hover:border-white/20 hover:bg-zinc-950/80 transition-colors"
                data-testid="contact-tile-order"
              >
                <Mail className="h-4 w-4 text-zinc-400" />
                <p className="mt-3 text-sm text-white">Order support</p>
                <p className="mt-1 text-xs text-zinc-500">
                  Delivery, revisions, orders
                </p>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
